





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import VButton from '@/components/miniComponents/VButton.vue'
import CreateParty from '@/components/home/CreateParty.vue'
import { Action, Getter, Mutation } from 'vuex-class'
import { ActionMethod, MutationMethod } from 'vuex'

const namespace = 'partyRoom'

@Component({
  components: {
    VButton
  }
})
export default class JoinParty extends Vue {
  @Action('fetchRoom', { namespace }) dispatchFetchRoom!: ActionMethod
  @Getter('partyID', { namespace }) partyID!: string
  @Mutation('clearRoom', { namespace }) clearRoom!: MutationMethod

  code = ''
  loading = false

  @Watch('partyID')
  onPartyIDChanged (val: string) {
    if (val.length > 0) this.$router.push('/enter')
  }

  mounted () {
    this.clearRoom()
  }

  changeMode () {
    this.$emit('changeMode', 'create')
  }

  async joinRoom () {
    if (this.code.length > 0) {
      this.loading = true
      try {
        await this.dispatchFetchRoom(this.code)
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
